import { render, staticRenderFns } from "./SelectReward.vue?vue&type=template&id=4855697b&"
import script from "./SelectReward.vue?vue&type=script&lang=ts&"
export * from "./SelectReward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports